import { render, staticRenderFns } from "./addContracts.vue?vue&type=template&id=6e95f3d7&scoped=true&"
import script from "./addContracts.vue?vue&type=script&lang=js&"
export * from "./addContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95f3d7",
  null
  
)

export default component.exports